module.exports = __webpack_public_path__ + "img/ic-status-loading-ac.7f0b83d0.svg";